module.exports = __webpack_public_path__ + "static/img/kenite.1117b35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/kenite.jpg
// module id = RK2T
// module chunks = 1